<template>
  <Teleport to="body">
    <div class="demo-modal__backdrop" @click.self="$emit('close')">
      <div
        class="demo-modal"
        role="dialog"
        aria-modal="true"
        aria-label="Book a Demo"
      >
        <div class="demo-modal__header">
          <h3 class="demo-modal__title">Book a Demo</h3>
          <button
            ref="closeBtn"
            class="demo-modal__close"
            @click="$emit('close')"
            aria-label="Close"
          >
            <svg
              width="14"
              height="14"
              viewBox="0 0 14 14"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M1 1L13 13M13 1L1 13"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
              />
            </svg>
          </button>
        </div>
        <div class="demo-modal__body">
          <div
            class="meetings-iframe-container"
            data-src="https://www.get.metime.com/meetings/peter-prendergast/metime-demo?embed=true"
          ></div>
        </div>
      </div>
    </div>
  </Teleport>
</template>

<script setup>
import { onMounted, onUnmounted, ref } from "vue";

const SCRIPT_URL =
  "https://static.hsappstatic.net/MeetingsEmbed/ex/MeetingsEmbedCode.js";

const emit = defineEmits(["close"]);
const closeBtn = ref(null);
let previousOverflow = "";

const handleKeydown = (e) => {
  if (e.key === "Escape") emit("close");
};

onMounted(() => {
  // Remove existing script so it re-runs against the freshly mounted div
  const existing = document.querySelector(`script[src="${SCRIPT_URL}"]`);
  if (existing) existing.remove();

  const script = document.createElement("script");
  script.type = "text/javascript";
  script.src = SCRIPT_URL;
  document.body.appendChild(script);

  previousOverflow = document.body.style.overflow;
  document.body.style.overflow = "hidden";
  document.addEventListener("keydown", handleKeydown);
  closeBtn.value?.focus();
});

onUnmounted(() => {
  document.body.style.overflow = previousOverflow;
  document.removeEventListener("keydown", handleKeydown);
});
</script>
